var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isGym())?_c('Gym',{attrs:{"users":_vm.users,"role":['gym','teacher'],"mobile":_vm.isMobile,"showFilters":false},on:{"refresh":function($event){return _vm.getAll()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }